export default "__VITE_ASSET__rnxHbsrf__"